<template lang="pug">
  
  .empty
    //- span(:style="{fontSize: '.5em', position: 'absolute'}") {{ item.starts_at | moment('H:mm') }}

</template>

<script>
import cellable from './mixins/cellable'

export default {

  mixins: [cellable],
}
</script>s